module.exports = __webpack_public_path__ + "static/media/a1.a380486f.jpg";